<script lang="ts">
  import Loading from "../components/Loading.svelte";

  export let title = undefined;
</script>

<svelte:head>
  <title>Loading</title>
</svelte:head>

<main>
  <Loading {title} />
</main>
